import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getRaffleById, endSession, getParticipants, checkUserPlayedRaffle } from "@network/Raffle";
import { getTicket } from "@network/Profile";
import { TicketScreen } from "@const/profile";
import { PaginateTicket } from "@network/Profile/type";
import { GetAvailableTicket, GetSelectLuckyNumber, SaveSelectLuckyNumber } from "@network/Dashboard";
import { SCREEN } from "@type/index";
import { updateNotice } from "@store/noticeReducer";
import { Errors } from "@const/error";
import { Successes } from "@const/success";
import { useDispatch } from "react-redux";
import * as _ from "lodash";

interface StateStatus {
  Available: string;
  Used: string;
  Registered: string;
  Expired: string;
}

const colorStatus: StateStatus = {
  Available: "#74ED2A",
  Used: "#66B2FF",
  Registered: "#F9C74F",
  Expired: "#F47C9A",
};

import {
  RaffleDetailType,
  WinResultType,
  RaffleStatus,
} from "@type/Raffle";
import { EVENTS } from "@const/events";
import { connect, emit, onEvent, disconnect } from "@network/socket";
// import defaultRaffleThumbnail from "@assets/img/raffle/defaultThumbnailRaffle.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import { faHashtag, faTimes } from "@fortawesome/free-solid-svg-icons";
import { trackUserEvent, trackFunnel } from "@utils/analytics";
import useAnalytics from "src/hooks/useAnalytics";

export interface TabBar {
  id: number;
  title: string;
  content: string;
}

const tab = [
  { id: 1, title: "Raffle", content: "Content for Tab 1" },
  { id: 2, title: "Participation", content: "Content for Tab 2" },
  { id: 3, title: "Rewards List", content: "Content for Tab 3" },
];

const FavoriteRaffle: React.FC = () => {
  const { id } = useParams();
  const raffleId = parseInt(id as string);
  const [shouldRefetchData, setShouldRefetchData] = useState<boolean>(false);
  const [raffle, setRaffle] = useState<RaffleDetailType>();
  // const [reward, setReward] = useState<RaffleReward>();
  const [winResult, setWinResult] = useState<WinResultType | null>(null);
  const [isTicketModalOpen, setIsTicketModalOpen] = useState(false);
  // const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
  const [isNumberSelectionModalOpen, setIsNumberSelectionModalOpen] = useState(false);
  const [isThankYouModalOpen, setIsThankYouModalOpen] = useState(false);
  const [ticketData, setTicketData] = useState<any>([]);
  // const [totalTicketPages, setTotalTicketPages] = useState(0);
  const [currentTicketPage, setCurrentTicketPage] = useState(1);
  // const [availableTickets, setAvailableTickets] = useState<any[]>([]);
  const [selectedTickets, setSelectedTickets] = useState<number[]>([]);
  const [luckyNumbers, setLuckyNumbers] = useState<any[]>([]);
  // const [numberRange, setNumberRange] = useState<{ start: number, end: number }>({ start: 1, end: 100 });
  const [selectedNumbers, setSelectedNumbers] = useState<number[]>([]);
  // const [totalSelected, setTotalSelected] = useState<number>(0);
  // const [randomAvailableList, setRandomAvailableList] = useState<number[]>([]);
  const [isLoadingNumbers, setIsLoadingNumbers] = useState(false);
  const [hasUserPlayed, setHasUserPlayed] = useState(false);
  // const [userPlayCount, setUserPlayCount] = useState(0);
  const [userLuckyNumbers, setUserLuckyNumbers] = useState<number[]>([]);
  // const [updateNumber, setUpdateNumber] = useState(1);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isTicketLoading, setIsTicketLoading] = useState(false);
  const [availableTickets, setAvailableTickets] = useState<number>(0);
  const [currentTime, setCurrentTime] = useState(moment());
  const { trackButtonClick } = useAnalytics();

  useEffect(() => {
    const fetchParticipants = async () => {
      const param = {
        limit: 10,
        offset: 0,
        id: raffleId,
      };
      const data = await getParticipants(param);
      setWinResult((prev) =>
        prev
          ? { ...prev, win: data.data.length }
          : { win: data.data.length, winner: 0, turn: 0, reward: "" }
      );
    };
    fetchParticipants();
  }, []);

  const onRaffleCancel = () => {
    fetchRaffleById(raffleId);
  };

  const onJoinRaffle = () => {
    // onEvent(EVENTS.SPIN_THE_PRIZE, onSpinThePrize);
    onEvent(EVENTS.RAFFLE_CANCELLED, onRaffleCancel);
  };

  const onConnect = () => {
    emit(EVENTS.JOIN_RAFFLE, { raffleId }, onJoinRaffle);
  };

  const fetchRaffleById = async (raffleId: number) => {
    try {
      const res = await getRaffleById(raffleId);

      setRaffle(res.data.raffle);
      // setReward(res.data.currentReward);

      // Check if user has already played this raffle
      await checkIfUserPlayed(raffleId);
    } catch (error) {
      console.log(error);
    }
  };

  const checkIfUserPlayed = async (raffleDrawId: number) => {
    try {
      const res = await checkUserPlayedRaffle(raffleDrawId);
      if (res.status === "success") {
        setHasUserPlayed(res.data.hasPlayed);
        // setUserPlayCount(res.data.playCount);
        setUserLuckyNumbers(res.data.luckyNumbers);
      }
    } catch (error) {
      console.log("Error checking if user played:", error);
      // If there's an error, assume user hasn't played to avoid blocking them
      setHasUserPlayed(false);
    }
  };

  const fetchEndSession = async (raffleId: number) => {
    try {
      await endSession(raffleId);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchRaffleById(raffleId);
    connect();
    onEvent(EVENTS.CONNECT, onConnect);

    return () => {
      disconnect();
      fetchEndSession(raffleId);
    };
  }, []);

  useEffect(() => {
    fetchRaffleById(raffleId);
  }, [winResult]);

  // Update current time every second for countdown
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(moment());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    if (isTicketModalOpen) {
      fetchTicketData();
    }
  }, [isTicketModalOpen, currentTicketPage]);

  useEffect(() => {
    if (isNumberSelectionModalOpen) {
      // fetchAvailableTickets();
      fetchLuckyNumbers();
    }
  }, [isNumberSelectionModalOpen]);


  const fetchTicketData = async () => {
    const paginate: PaginateTicket = {
      limit: 20,
      offset: (currentTicketPage - 1) * 20,
      screen: TicketScreen.MY_TICKET_LIST,
    };

    try {
      const response = await getTicket(paginate);
      const datarows = response.data.tickets;

      // Simply set the raw ticket data - filtering will happen in the render
      setTicketData(datarows);
      // setTotalTicketPages(Math.ceil(response.data.total / 20));
    } catch (error) {
      console.error("Error fetching ticket data:", error);
    }
  };

  const activeTickets = Array.isArray(ticketData)
    ? ticketData.filter(
      (ticket: any) =>
        ticket.status.toLowerCase() === "available"
    ).length
    : 0;

  const fetchAvailableTickets = async () => {
    try {
      setIsLoadingNumbers(true);
      setIsTicketLoading(true);
      const res = await GetAvailableTicket({ type: raffle?.type });

      if (res.status === "success") {
        const tickets = res.data.tickets.map((ticket: any) => ({
          id: ticket.id,
          value: ticket.id,
          label: ticket.title,
          expiredDate: ticket.expiredDate,
        }));
        setAvailableTickets(tickets);
        setIsTicketLoading(false);
      }
    } catch (error) {
      console.error("Error fetching available tickets:", error);
      updateNotice(
        {
          type: "ERROR",
          content: Errors.UNKNOWN,
        },
        dispatch
      );
    } finally {
      setIsLoadingNumbers(false);
      setIsTicketLoading(false);
    }
  };

  const fetchLuckyNumbers = async () => {
    if (!raffleId) return;

    try {
      const data = {
        raffleId: raffleId,
        screen: SCREEN.SELECT_LUCKY_NUMBER,
      };

      const res = await GetSelectLuckyNumber(data);

      if (res.status === "success") {
        setLuckyNumbers(res.data.luckyNumbers);
        const availableCount = _.reduce((res.data.luckyNumbers), (count: number, item) => {
          if (!item.selected) {
            return count + 1
          }
          return count;
        }, 0);

        setAvailableTickets(availableCount)

        // setNumberRange(res.data.range);
        // setTotalSelected(res.data.totalSelected);

        // Get available numbers (not selected by others)
        // const availableNumbers = _.reduce(
        //   res.data.luckyNumbers,
        //   (data: number[], item) => {
        //     if (!item.selected) {
        //       data.push(item.number);
        //     }
        //     return data;
        //   },
        //   []
        // );
        // setRandomAvailableList(availableNumbers);
      }
    } catch (error) {
      console.error("Error fetching lucky numbers:", error);
      updateNotice(
        {
          type: "ERROR",
          content: Errors.UNKNOWN,
        },
        dispatch
      );
    }
  };

  const updateNumberSelection = (number: number) => {
    // Check if the number is already selected
    if (selectedNumbers.includes(number)) {
      // Deselect the number (remove it from the array)
      setSelectedNumbers(selectedNumbers.filter((num) => num !== number));
    } else {
      // Select the new number and automatically deselect any previously selected numbers
      // This creates a radio button-like behavior where only one number can be selected at a time
      setSelectedNumbers([number]);
    }
  };

  const handleNumberSubmit = async () => {
    if (!raffleId || selectedNumbers.length === 0 || selectedTickets.length === 0) return;

    const payload = {
      raffleId: raffleId,
      data: {
        luckyNumbers: selectedNumbers,
        ticketIds: selectedTickets,
      },
    };

    try {
      setIsLoadingNumbers(true);
      const res = await SaveSelectLuckyNumber(payload);

      if (res.status === "success") {
        setIsNumberSelectionModalOpen(false);
        // setIsThankYouModalOpen(true);
        setShouldRefetchData(!shouldRefetchData);
        // setUpdateNumber(prev => prev + 1);
        updateNotice(
          {
            type: "SUCCESS",
            content: Successes.SAVE_SUCCESS,
          },
          dispatch
        );
        // Reset states
        // if (updateNumber === 2) {
        setIsThankYouModalOpen(true);
        fetchRaffleById(raffleId);

        // Track raffle entry
        trackUserEvent.raffleEnter(
          raffleId,
          raffle?.title || "Unknown Raffle",
          selectedTickets.length
        );

        // setUpdateNumber(1);
        // setIsSuccessModalOpen(false);
        // } else {
        //   setIsSuccessModalOpen(true);
        // }
        setSelectedNumbers([]);
        // setSelectedTickets([]);
      } else {
        updateNotice(
          {
            type: "ERROR",
            content: Errors[res.message] ? Errors[res.message] : Errors.FAILED_TO_SUBMIT_RAFFLE,
          },
          dispatch
        );
        // Refresh the data
        fetchLuckyNumbers();
        setSelectedNumbers([]);
      }
    } catch (error) {
      console.error("Error saving lucky numbers:", error);
      updateNotice(
        {
          type: "ERROR",
          content: Errors.UNKNOWN,
        },
        dispatch
      );
    } finally {
      setIsLoadingNumbers(false);
    }
  };

  const renderTicketModal = () => {
    if (!isTicketModalOpen) return null;

    // If user has already played, don't show the modal
    if (hasUserPlayed) {
      return null;
    }

    // Get first available ticket
    const firstAvailableTicket = Array.isArray(ticketData)
      ? ticketData.find((ticket: any) => ticket.status.toLowerCase() === 'available')
      : null;

    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm p-2 md:!p-4" onClick={() => setIsTicketModalOpen(false)}>
        <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md overflow-hidden" onClick={(e) => e.stopPropagation()}>

          {/* Header */}
          <div className="bg-gradient-to-r from-[#4B975B] to-[#ACC992] px-6 py-6 text-center relative">
            <div className="absolute inset-0 opacity-10">
              <div className="absolute top-0 left-0 w-32 h-32 bg-white rounded-full -translate-x-1/2 -translate-y-1/2"></div>
              <div className="absolute bottom-0 right-0 w-40 h-40 bg-white rounded-full translate-x-1/3 translate-y-1/3"></div>
            </div>
            <button
              className="absolute top-4 right-4 z-10 w-10 h-10 flex items-center justify-center rounded-full bg-white/90 hover:bg-white text-black transition-colors shadow-lg"
              onClick={() => setIsTicketModalOpen(false)}
            >
              <FontAwesomeIcon icon="times" />
            </button>

            <div className="w-20 h-20 mx-auto mb-4 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center">
              <svg className="w-10 h-10 text-white" fill="currentColor" viewBox="0 0 20 20">
                <path d="M2 6a2 2 0 012-2h12a2 2 0 012 2v2a2 2 0 100 4v2a2 2 0 01-2 2H4a2 2 0 01-2-2v-2a2 2 0 100-4V6z" />
              </svg>
            </div>

            <h2 className="text-2xl font-extrabold text-white mb-1">
              Use Your Ticket
            </h2>
            <p className="text-white/90 text-sm">
              Enter the raffle and pick your lucky number
            </p>
          </div>

          {/* Content */}
          <div className="p-8">
            {isTicketLoading ? (
              <div className="flex flex-col items-center justify-center h-64">
                <svg
                  className="w-12 h-12 text-gray-400 animate-spin"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  ></circle>
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8v8H4z"
                  ></path>
                </svg>
                <p className="mt-4 text-sm text-gray-500">Loading tickets...</p>
              </div>
            ) : activeTickets > 0 ? (
              <>
                {/* Available Tickets Display */}
                <div className="bg-gradient-to-br from-[#4B975B]/10 to-[#ACC992]/10 rounded-xl p-6 mb-6 border-2 border-[#4B975B]/20">
                  <div className="text-center">
                    <p className="text-sm font-medium text-[#6a7b76] mb-2">
                      Available Tickets
                    </p>
                    <div className="flex items-center justify-center gap-2">
                      <span className="text-5xl font-extrabold text-[#4B975B]">
                        {activeTickets}
                      </span>
                      <svg className="w-8 h-8 text-[#4B975B]" fill="currentColor" viewBox="0 0 20 20">
                        <path d="M2 6a2 2 0 012-2h12a2 2 0 012 2v2a2 2 0 100 4v2a2 2 0 01-2 2H4a2 2 0 01-2-2v-2a2 2 0 100-4V6z" />
                      </svg>
                    </div>
                    <p className="text-xs text-[#6a7b76] mt-2">
                      {activeTickets === 1 ? 'ticket ready to use' : 'tickets ready to use'}
                    </p>
                  </div>
                </div>

                {/* Info Message */}
                <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
                  <div className="flex gap-3">
                    <svg className="w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                    </svg>
                    <div>
                      <p className="text-sm font-semibold text-blue-900 mb-1">
                        How it works
                      </p>
                      <p className="text-xs text-blue-700">
                        Click "Use 1 Ticket" to proceed to number selection. You'll pick your lucky number to enter the raffle.
                      </p>
                    </div>
                  </div>
                </div>

                {/* Use Ticket Button */}
                <button
                  className="w-full py-4 bg-gradient-to-r from-[#4B975B] to-[#ACC992] text-white text-lg font-bold rounded-xl hover:shadow-lg hover:scale-[1.02] transition-all duration-200 flex items-center justify-center gap-2"
                  onClick={() => {
                    if (firstAvailableTicket) {
                      setSelectedTickets([firstAvailableTicket.id]);
                      setIsTicketModalOpen(false);
                      setIsNumberSelectionModalOpen(true);
                    }
                  }}
                >
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                  </svg>
                  Use 1 Ticket
                </button>

                {/* Footer Note */}
                <p className="text-center text-xs text-[#6a7b76] mt-4">
                  You have <span className="font-bold text-[#4B975B]">{activeTickets - 1}</span> {activeTickets - 1 === 1 ? 'ticket' : 'tickets'} remaining after this
                </p>
              </>
            ) : (
              /* No Tickets State */
              <>
                <div className="text-center py-6">
                  <div className="w-20 h-20 mx-auto mb-4 bg-gray-100 rounded-full flex items-center justify-center">
                    <svg className="w-10 h-10 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 5v2m0 4v2m0 4v2M5 5a2 2 0 00-2 2v3a2 2 0 110 4v3a2 2 0 002 2h14a2 2 0 002-2v-3a2 2 0 110-4V7a2 2 0 00-2-2H5z" />
                    </svg>
                  </div>
                  <h3 className="text-xl font-bold text-[#1f2c2b] mb-2">
                    No Tickets Available
                  </h3>
                  <p className="text-[#6a7b76] mb-6 text-sm">
                    You need tickets to enter this raffle. Generate tickets by answering questions or completing tasks.
                  </p>
                  <button
                    className="px-6 py-3 bg-gradient-to-r from-[#4B975B] to-[#ACC992] text-white font-semibold rounded-lg hover:shadow-lg transition-all duration-200"
                    onClick={() => {
                      setIsTicketModalOpen(false);
                      navigate('/ticket-generator');
                    }}
                  >
                    Generate Tickets
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    );
  };

  // const renderSuccessModal = () => {
  //   if (!isSuccessModalOpen) return null;

  //   return (
  //     <div className="success-modal-overlay" onClick={() => setIsSuccessModalOpen(false)}>
  //       <div className="success-modal-content" onClick={(e) => e.stopPropagation()}>
  //         {/* <button
  //           className="success-modal-close"
  //           onClick={() => setIsSuccessModalOpen(false)}
  //         >
  //           ×
  //         </button> */}

  //         <div className="success-modal-body">
  //           <h1 className="success-title">You are in the Raffle!</h1>
  //           <p className="success-subtitle">Get another entry! Maximise Chances!</p>
  //           <button
  //             className="double-chance-btn"
  //             onClick={() => {
  //               setIsSuccessModalOpen(false);
  //               setIsNumberSelectionModalOpen(true);
  //             }}
  //           >
  //             DOUBLE MY CHANCE!
  //           </button>
  //           <p className="success-footer">Max 2 entries per raffle / per user everyday.</p>
  //           <p className="success-footer">*Terms and Conditions Apply. Violators will be banned </p>
  //         </div>
  //       </div>
  //     </div>
  //   );
  // };

  const renderThankYouModal = () => {
    if (!isThankYouModalOpen) return null;

    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm">
        <div className="relative w-full max-w-md bg-white rounded-2xl overflow-hidden shadow-2xl">
          {/* Close Button */}
          <button
            onClick={() => setIsThankYouModalOpen(false)}
            className="absolute top-4 right-4 z-10 w-10 h-10 flex items-center justify-center rounded-full bg-gray-100 text-black hover:bg-gray-200 transition-colors"
          >
            <FontAwesomeIcon icon={faTimes} />
          </button>

          {/* Header with Gradient */}
          <div className="relative bg-gradient-to-r from-[#4B975B] to-[#5DAD6D] p-6 text-center overflow-hidden">
            <div className="absolute inset-0 opacity-10">
              <div className="absolute top-0 left-0 w-32 h-32 bg-white rounded-full -translate-x-1/2 -translate-y-1/2"></div>
              <div className="absolute bottom-0 right-0 w-40 h-40 bg-white rounded-full translate-x-1/3 translate-y-1/3"></div>
            </div>

            <div className="relative">
              <div className="inline-flex items-center justify-center w-20 h-20 mx-auto mb-4 bg-white/20 backdrop-blur-sm rounded-full">
                <svg className="w-12 h-12 text-white" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" />
                </svg>
              </div>
              <h1 className="text-2xl font-extrabold text-white mb-2">You're in the Raffle! 🎉</h1>
              <p className="text-white/90">Your entry has been successfully submitted</p>
            </div>
          </div>

          {/* Content */}
          <div className="p-6 space-y-6">
            <div className="text-center">
              <p className="text-gray-700 mb-6">
                ALL THE BEST! 🚀 Hold your breath for the results.
              </p>

              <div className="space-y-4">
                <button
                  onClick={() => {
                    setIsThankYouModalOpen(false);
                    navigate("/dashboard");
                  }}
                  className="w-full py-3 px-6 bg-gradient-to-r from-[#4B975B] to-[#5DAD6D] text-white font-semibold rounded-lg hover:shadow-lg transition-all duration-200 transform hover:scale-[1.02]"
                >
                  Back To All Games
                </button>
              </div>
            </div>

            <div className="text-center pt-4 border-t border-gray-100">
              <p className="text-xs text-gray-500">
                Winners will be notified by SMS and Email (if provided).<br />
                *Terms and Conditions Apply
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderNumberSelectionModal = () => {
    if (!isNumberSelectionModalOpen) return null;
    return (
      <div
        className="number-selection-modal-overlay"
        onClick={() => setIsNumberSelectionModalOpen(false)}
      >
        <div
          className="number-selection-modal-content"
          onClick={(e) => e.stopPropagation()}
        >
          <button
            className="number-selection-modal-close"
            onClick={() => setIsNumberSelectionModalOpen(false)}
          >
            ×
          </button>

          <div className="number-selection-modal-body">
            <div className="mb-6 text-center">
              <h1 className="text-2xl font-bold text-[#4B975B] mb-2">
                Select Your Lucky Number
              </h1>
              <p className="text-sm text-gray-600">
                Choose your lucky number to enter the raffle!
              </p>
            </div>
            <div className="bg-[#F5F9E9] px-6 py-4 border-b-2 border-[#4B975B]/30 mb-6 rounded-lg shadow-sm">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-sm">
                <div className="flex items-center gap-3">
                  <svg className="w-5 h-5 text-[#4B975B]" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M10 2a1 1 0 00-1 1v14a1 1 0 102 0V3a1 1 0 00-1-1zM4.293 7.293a1 1 0 011.414 0L10 11.586l4.293-4.293a1 1 0 111.414 1.414l-5 5a1 1 0 01-1.414 0l-5-5a1 1 0 010-1.414z" />
                  </svg>
                  <div>
                    <p className="text-xs text-gray-500">Raffle Title</p>
                    <p className="font-bold text-[#4B975B]">{raffle?.title || "N/A"}</p>
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  <svg className="w-5 h-5 text-[#4B975B]" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd" />
                  </svg>
                  <div>
                    <p className="text-xs text-gray-500">{raffle?.type?.toLowerCase() === 'weekly' ? 'Result Date' : 'Raffle Date'}</p>
                    <p className="font-bold text-[#4B975B]">
                      {raffle?.type?.toLowerCase() === 'weekly' ? (
                        <div className="flex flex-col">
                          <span className="text-[10px] text-gray-500 font-normal">
                            ({moment(raffle.startTime).format('DD MMM')} - {moment(raffle.expiryDate).format('DD MMM, YYYY')})
                          </span>
                        </div>
                      ) : (
                        raffle?.startTime && new Date(raffle.startTime).toLocaleDateString("en-GB", {
                          day: "numeric",
                          month: "short",
                          year: "numeric",
                        })
                      )}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {isLoadingNumbers ? (
              <div className="flex items-center justify-center py-10">
                <svg
                  className="w-8 h-8 text-[#4B975B] animate-spin"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  ></circle>
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8v8H4z"
                  ></path>
                </svg>
                <p className="ml-3 text-sm text-gray-600">Loading numbers...</p>
              </div>
            ) : (
              <>
                {/* Show selected tickets info */}
                {/* {availableTickets.length > 0 && (
                  <div className="selected-tickets-info">
                    <h3>Available Tickets:</h3>
                    <div className="tickets-list">
                      {availableTickets.map((ticket) => (
                        <label key={ticket.id} className="ticket-checkbox">
                          <input
                            type="checkbox"
                            checked={selectedTickets.includes(ticket.id)}
                            onChange={(e) => {
                              if (e.target.checked) {
                                setSelectedTickets([...selectedTickets, ticket.id]);
                              } else {
                                setSelectedTickets(selectedTickets.filter(id => id !== ticket.id));
                              }
                            }}
                          />
                          {ticket.label}
                        </label>
                      ))}
                    </div>
                  </div>
                )} */}

                {/* Legend */}
                <div className="number-selection-legend">
                  <div className="number-legend-item">
                    <div className="number-legend-box currently-selected">{availableTickets}</div>
                    <span>Available</span>
                  </div>
                  {/* <div className="number-legend-item">
                    <div className="number-legend-box selected-by-others">01</div>
                    <span>Selected</span>
                  </div> */}
                  <div className="number-legend-item">
                    <div className="number-legend-box unavailable">{100 - availableTickets}</div>
                    <span>Unavailable</span>
                  </div>
                </div>

                {/* Number Grid */}
                {luckyNumbers.length > 0 ? (
                  <div className="number-selection-grid">
                    {luckyNumbers.map((numberData) => {
                      const isSelectedByOthers = numberData.selected;
                      const isCurrentlySelected = selectedNumbers.includes(numberData.number);

                      return (
                        <button
                          key={numberData.number}
                          className={`number-selection-box ${isSelectedByOthers ? 'unavailable' :
                            isCurrentlySelected ? 'selected-by-others' :
                              'available'
                            }`}
                          disabled={isSelectedByOthers}
                          onClick={() => !isSelectedByOthers && updateNumberSelection(numberData.number)}
                        >
                          {numberData.number.toString().padStart(2, '0')}
                        </button>
                      );
                    })}
                  </div>
                ) : (
                  <div className="no-numbers-message">
                    <p>Loading available numbers...</p>
                  </div>
                )}

                {/* Selected numbers display
                {selectedNumbers.length > 0 && (
                  <div className="selected-numbers-display">
                    <h4>Selected Numbers: {selectedNumbers.join(', ')}</h4>
                    <p>You can select up to {selectedTickets.length} numbers</p>
                  </div>
                )} */}
                {/* Submit Button */}
                <button
                  className={`number-selection-submit-btn ${selectedNumbers.length === 0 || selectedTickets.length === 0 || isLoadingNumbers ? 'disabled' : ''
                    }`}
                  disabled={selectedNumbers.length === 0 || selectedTickets.length === 0 || isLoadingNumbers}
                  onClick={handleNumberSubmit}
                >
                  {isLoadingNumbers ? "Submitting..." : "Confirm Selection"}
                </button>

                <div className="mt-6 pt-4 border-t border-gray-200">
                  <div className="bg-[#F5F9E9] rounded-lg p-4 text-xs text-gray-600 leading-relaxed">
                    <p className="font-semibold text-gray-800 mb-2 flex items-start gap-2">
                      <svg className="w-4 h-4 text-[#4B975B] flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                      </svg>
                      Important Notice:
                    </p>
                    <ul className="space-y-1 ml-6 list-disc">
                      <li>All draws take place at scheduled time automatically.</li>
                      <li>Numbers are selected at random.</li>
                      <li>All results are final and binding.</li>
                      <li>Rewards cannot be exchanged for cash.</li>
                      <li>Terms and Conditions Apply.</li>
                    </ul>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    );
  };

  const getDynamicRaffleImage = (raffle: RaffleDetailType | undefined) => {
    if (!raffle) return "";

    // Only apply this logic for Daily and Weekly raffles
    if (raffle.type.toLowerCase() !== 'daily' && raffle.type.toLowerCase() !== 'weekly') {
      return raffle.thumbnailImg || raffle.bannerImg || raffle.bannerUrl || "";
    }

    const isWeekly = raffle.type.toLowerCase() === 'weekly';
    const referenceDate = isWeekly ? moment(raffle.expiredDate).local() : moment(raffle.startTime).local();

    const dayName = referenceDate.format('dddd').toUpperCase();
    const dayDigit = referenceDate.format('DD');
    const monthName = referenceDate.format('MMMM').toUpperCase();

    const statusStr = (raffle.status || "").toString().toUpperCase();
    const isLive = statusStr === RaffleStatus.ELIGIBLE || statusStr === RaffleStatus.HAPPENING || statusStr === 'ACTIVE';
    const isDone = statusStr === RaffleStatus.DONE;

    let state = "COMING SOON";
    if (isLive) state = "LIVE";
    if (isDone) state = "END";

    // Standardized format: "/raffle/[DAY] [DD] [MONTH] [STATE].png"
    return `/raffle/${dayName} ${dayDigit} ${monthName} ${state}.png`;
  };

  return (
    <>
      {/* Modern Comprehensive Raffle Hero Section */}
      <section className="relative bg-gradient-to-br from-[#4B975B] via-[#5dad6d] to-[#4B975B] overflow-hidden">
        {/* Background Pattern */}
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-0 left-0 w-32 h-32 sm:w-48 sm:h-48 md:w-64 md:h-64 bg-white rounded-full -translate-x-1/2 -translate-y-1/2"></div>
          <div className="absolute bottom-0 right-0 w-48 h-48 sm:w-64 sm:h-64 md:w-96 md:h-96 bg-white rounded-full translate-x-1/3 translate-y-1/3"></div>
        </div>

        <div className="relative container mx-auto px-4 sm:px-6 md:px-8 lg:px-12 py-8 sm:py-10 md:py-12 lg:py-16">
          {/* Top Section - Title and Date */}
          <div className="text-center text-white mb-8 sm:mb-10">
            <div className="inline-flex items-center gap-2 sm:gap-3 bg-white/30 backdrop-blur-sm px-4 py-2 sm:px-5 sm:py-3 rounded-full mb-4 sm:mb-6 shadow-lg">
              <svg className="w-5 h-5 sm:w-6 sm:h-6" fill="currentColor" viewBox="0 0 20 20">
                <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
              </svg>
              <span className="text-sm sm:text-base font-bold uppercase tracking-wider text-white drop-shadow-sm">
                {raffle?.status === RaffleStatus.ELIGIBLE || raffle?.status === RaffleStatus.HAPPENING
                  ? 'Live Raffle - Join Now!'
                  : raffle?.status === RaffleStatus.DONE
                    ? 'Completed Raffle - See Results'
                    : 'Upcoming Raffle - Get Ready!'}
              </span>
            </div>
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold mb-4 sm:mb-6">
              Raffle of the {raffle?.type.toLowerCase() === 'daily' ? 'Day' : raffle?.type.toLowerCase() === 'weekly' ? 'Week' : raffle?.type.toLowerCase() === 'monthly' ? 'Month' : raffle?.type.toLowerCase() === 'quarterly' ? 'Quarter' : raffle?.type.toLowerCase() === 'annually' ? 'Year' : 'Season'}
            </h1>
            <div className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-extrabold text-white">
              {raffle?.type?.toLowerCase() === 'weekly' ? (
                <div className="flex flex-col items-center">
                  {/* <span className="text-yellow-400">Result Date: {moment(raffle.expiredDate).format('DD MMM, YYYY')}</span> */}
                  <span className="">
                    ({moment(raffle.startTime).format('DD MMM')} - {moment(raffle.expiryDate).format('DD MMM, YYYY')})
                  </span>
                </div>
              ) : (
                <span className="text-yellow-400">
                  {raffle?.startTime && new Date(raffle.startTime).toLocaleDateString("en-GB", {
                    day: "numeric",
                    month: "short",
                    year: "numeric",
                  })}
                </span>
              )}
            </div>
          </div>

          {/* Main Content Grid */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 sm:gap-8 lg:gap-12">

            {/* Left Section - Prize Image */}
            <div className="flex items-center justify-center px-2 sm:px-0">
              <div className="relative w-full max-w-[280px] sm:max-w-[340px] md:max-w-[400px] lg:max-w-lg">
                {/* Glow Effect */}
                <div className="absolute inset-0 bg-white/20 rounded-full blur-2xl sm:blur-3xl"></div>

                {/* Prize Card */}
                <div className="relative bg-white/10 backdrop-blur-md rounded-2xl sm:rounded-3xl p-4 sm:p-5 md:p-6 border border-white/20 shadow-xl sm:shadow-2xl">
                  {/* Status Badge */}
                  {raffle?.status === RaffleStatus.ELIGIBLE || raffle?.status === RaffleStatus.HAPPENING ? (
                    <div className="absolute -top-2 left-3 sm:-top-3 sm:left-4 md:left-6 bg-red-600 text-white px-3 py-1.5 sm:px-4 sm:py-2 rounded-full text-xs sm:text-sm font-bold flex items-center gap-1.5 sm:gap-2 animate-pulse z-10">
                      <div className="w-2 h-2 sm:w-2.5 sm:h-2.5 bg-white rounded-full animate-ping absolute opacity-75"></div>
                      <div className="w-1.5 h-1.5 sm:w-2 sm:h-2 bg-white rounded-full"></div>
                      <span className="drop-shadow-md">LIVE NOW</span>
                    </div>
                  ) : raffle?.status === RaffleStatus.DONE ? (
                    <div className="absolute -top-2 left-3 sm:-top-3 sm:left-4 md:left-6 bg-[#4b975b] text-white px-3 py-1.5 sm:px-4 sm:py-2 rounded-full text-xs sm:text-sm font-bold flex items-center gap-1.5 sm:gap-2 z-10">
                      <div className="w-1.5 h-1.5 sm:w-2 sm:h-2 bg-white rounded-full"></div>
                      <span className="drop-shadow-md">COMPLETED</span>
                    </div>
                  ) : (
                    <div className="absolute -top-2 left-3 sm:-top-3 sm:left-4 md:left-6 bg-blue-600 text-white px-3 py-1.5 sm:px-4 sm:py-2 rounded-full text-xs sm:text-sm font-bold flex items-center gap-1.5 sm:gap-2 z-10">
                      <div className="w-1.5 h-1.5 sm:w-2 sm:h-2 bg-white rounded-full"></div>
                      <span className="drop-shadow-md">UPCOMING</span>
                    </div>
                  )}

                  {/* Grand Prize Badge */}
                  <div className="absolute -top-2 right-3 sm:-top-3 sm:right-4 md:right-6 bg-yellow-400 text-yellow-900 px-2 py-1.5 sm:px-3 sm:py-2 md:px-4 md:py-2 rounded-full text-[10px] sm:text-xs md:text-sm font-bold shadow-lg z-10">
                    <span className="hidden sm:inline">🏆 {raffle?.nextRewardTitle || "Grand Prize"}</span>
                    <span className="sm:hidden">🏆 Prize</span>
                  </div>

                  {/* Prize Image with Skeleton Loader */}
                  <div className="relative rounded-xl sm:rounded-2xl overflow-hidden w-full aspect-square shadow-lg">
                    <div className="relative w-full h-full">
                      {/* Skeleton Loader */}
                      <div className="absolute inset-0 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 bg-[length:200%_100%] animate-pulse rounded-xl sm:rounded-2xl"></div>

                      {/* Actual Image */}
                      <img
                        src={getDynamicRaffleImage(raffle)}
                        alt={raffle?.title || "Contest Prize"}
                        className="relative w-full h-full object-cover transition-opacity duration-300 ease-in-out group-hover:opacity-90"
                        onLoad={(e) => {
                          const img = e.target as HTMLImageElement;
                          img.style.opacity = '1';
                        }}
                        onError={(e) => {
                          const img = e.target as HTMLImageElement;
                          if (img.src.includes('COMING%20SOON')) {
                            img.src = img.src.replace('COMING%20SOON', 'LIVE');
                          } else {
                            img.src = raffle?.thumbnailImg || raffle?.bannerImg || raffle?.bannerUrl || "";
                            img.style.opacity = '1';
                            img.onerror = null;
                          }
                        }}
                        style={{
                          opacity: 0,
                          transition: 'opacity 0.3s ease-in-out'
                        }}
                      />
                    </div>
                  </div>

                  {/* Prize Info */}
                  <div className="mt-4 sm:mt-5 md:mt-6 text-center text-white">
                    <h2 className="text-lg sm:text-xl md:text-2xl lg:text-3xl font-bold mb-1 sm:mb-2">
                      {raffle?.nextRewardTitle || "Exciting Rewards Await!"}
                    </h2>
                    <p className="text-sm sm:text-base md:text-lg opacity-90">
                      {raffle?.nextRewardTitle ? "" : ""}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Section - Contest Details */}
            <div className="flex flex-col justify-center space-y-4 sm:space-y-5 md:space-y-6 mt-6 lg:mt-0">
              {/* Raffle Title */}
              <div className="text-white">
                <h2 className="text-2xl sm:text-3xl md:text-4xl font-extrabold mb-2 sm:mb-3">
                  {raffle?.title || "Amazing Raffle Contest"}
                </h2>
                <p className="text-sm sm:text-base md:text-lg opacity-90">
                  {raffle?.description || "Join the fun & win prizes - Every single day!"}
                </p>
              </div>

              {/* Countdown Timer */}
              <div className="bg-white/10 backdrop-blur-md rounded-xl sm:rounded-2xl p-4 sm:p-5 md:p-6 border border-white/20">
                {(() => {
                  if (!raffle?.startTime && !raffle?.endTime) {
                    return (
                      <div className="text-center py-4">
                        <p className="text-xl font-bold text-white">⏰ Time not set</p>
                      </div>
                    );
                  }

                  const now = currentTime; // Use current time state that updates every second
                  const startTime = moment(raffle.startTime);
                  const endTime = moment(raffle.endTime);

                  // Convert UTC to local time
                  const localStartTime = startTime.local();
                  const localEndTime = endTime.local();
                  const nextStartTime = raffle.startTime
                    ? localStartTime.clone().add(1, 'day')
                    : null;

                  // Check if raffle has started but not ended
                  const hasStarted = now.isSameOrAfter(localStartTime);
                  const hasEnded = now.isSameOrAfter(localEndTime);

                  let targetTime;
                  let labelText;

                  if (!hasStarted) {
                    targetTime = localStartTime;
                    labelText = "Entries Open in:";
                  } else if (!hasEnded) {
                    targetTime = localEndTime;
                    labelText = "Entries Close in:";
                  } else {
                    return (
                      <div className="text-center py-3 sm:py-4">
                        <span className="text-2xl sm:text-3xl md:text-4xl">🎉</span>
                        <p className="text-base sm:text-lg md:text-xl font-bold text-white mt-2">Contest Ended</p>
                      </div>
                    );
                  }

                  const diff = targetTime.diff(now);

                  if (diff > 0) {
                    const duration = moment.duration(diff);
                    const days = Math.floor(duration.asDays());
                    const hours = duration.hours();
                    const minutes = duration.minutes();
                    const seconds = duration.seconds();

                    const timeUnits = [];
                    if (days > 0) {
                      timeUnits.push({ value: days, label: "Days" });
                      timeUnits.push({ value: hours, label: "Hours" });
                      timeUnits.push({ value: minutes, label: "Mins" });
                    } else if (hours > 0) {
                      timeUnits.push({ value: hours, label: "Hours" });
                      timeUnits.push({ value: minutes, label: "Mins" });
                      timeUnits.push({ value: seconds, label: "Secs" });
                    } else {
                      timeUnits.push({ value: minutes, label: "Mins" });
                      timeUnits.push({ value: seconds, label: "Secs" });
                    }

                    return (
                      <div className="space-y-2 sm:space-y-3">
                        <p className="text-xs md:text-lg font-semibold text-white text-center">
                          ⏰ {labelText}
                        </p>
                        <div className="flex items-center justify-center gap-2 sm:gap-3">
                          {timeUnits.map((unit, index) => (
                            <React.Fragment key={unit.label}>
                              <div className="bg-white rounded-lg sm:rounded-xl px-2 py-2 sm:px-3 sm:py-2.5 md:px-4 md:py-3 shadow-md min-w-[50px] sm:min-w-[60px] md:min-w-[70px] text-center border-2 border-white/30">
                                <div className="text-xl sm:text-2xl md:text-3xl font-black text-[#4B975B]">
                                  {unit.value.toString().padStart(2, "0")}
                                </div>
                                <div className="text-[9px] sm:text-xs font-semibold text-[#6a7b76] uppercase mt-0.5 sm:mt-1">
                                  {unit.label}
                                </div>
                              </div>
                              {index < timeUnits.length - 1 && (
                                <div className="text-lg sm:text-xl md:text-2xl font-bold text-white">:</div>
                              )}
                            </React.Fragment>
                          ))}
                        </div>
                      </div>
                    );
                  } else {
                    return (
                      <div className="text-center py-3 sm:py-4">
                        <span className="text-2xl sm:text-3xl md:text-4xl">🎉</span>
                        <p className="text-base sm:text-lg md:text-xl font-bold text-white mt-2">Contest Started!</p>
                      </div>
                    );
                  }
                })()}
              </div>

              {/* Raffle Details */}
              <div className="grid grid-cols-2 gap-3 sm:gap-4">
                <div className="bg-white/10 backdrop-blur-md rounded-lg sm:rounded-xl p-3 sm:p-4 border border-white/20">
                  <div className="flex items-center gap-1.5 sm:gap-2 mb-1.5 sm:mb-2">
                    <svg className="w-4 h-4 sm:w-5 sm:h-5 text-white flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                      <path d="M9 6a3 3 0 11-6 0 3 3 0 016 0zM17 6a3 3 0 11-6 0 3 3 0 016 0zM12.93 17c.046-.327.07-.66.07-1a6.97 6.97 0 00-1.5-4.33A5 5 0 0119 16v1h-6.07zM6 11a5 5 0 015 5v1H1v-1a5 5 0 015-5z" />
                    </svg>
                    <span className="text-xs sm:text-sm text-white/80">Participants</span>
                  </div>
                  <p className="text-xl sm:text-2xl font-bold text-white">{raffle?.numberOfParticipants || 0}</p>
                </div>

                <div className="bg-white/10 backdrop-blur-md rounded-lg sm:rounded-xl p-3 sm:p-4 border border-white/20">
                  <div className="flex items-center gap-1.5 sm:gap-2 mb-1.5 sm:mb-2">
                    <FontAwesomeIcon icon={faHashtag} className="w-4 h-4 sm:w-5 sm:h-5 text-white flex-shrink-0" />
                    <span className="text-xs sm:text-sm text-white/80">Total Turn</span>
                  </div>
                  <p className="text-xl sm:text-2xl font-bold text-white">{raffle?.numberOfTurns || 0}</p>
                </div>
              </div>

              {/* CTA Button */}
              <button
                onClick={() => {
                  if (hasUserPlayed) {
                    updateNotice(
                      {
                        type: "ERROR",
                        content: `You have already played this raffle. Selected numbers: ${userLuckyNumbers.join(', ')}`,
                      },
                      dispatch
                    );
                  } else {
                    setIsTicketModalOpen(true);
                  }
                }}
                className={`group w-full px-6 py-3.5 sm:px-7 sm:py-4 md:px-8 md:py-5 rounded-xl sm:rounded-2xl font-bold text-base sm:text-lg md:text-xl shadow-lg sm:shadow-xl md:shadow-2xl transition-all duration-300 disabled:bg-gray-400 disabled:text-gray-700 cursor-not-allowed bg-white text-[#4B975B] hover:shadow-3xl hover:scale-105`}
                disabled={hasUserPlayed || raffle?.status === RaffleStatus.WAITING_PEOPLE || raffle?.status === RaffleStatus.CANCEL || raffle?.status === RaffleStatus.DONE}
              >
                {hasUserPlayed ? "Already Played" : "Play Now & Win!"}
              </button>

              {/* Show user's selected numbers if they've played */}
              {hasUserPlayed && userLuckyNumbers.length > 0 && (
                <div className="bg-blue-50 border border-blue-200 rounded-lg sm:rounded-xl p-3 sm:p-4 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
                  <div className="flex items-start gap-2 sm:gap-3 flex-1">
                    <svg className="w-4 h-4 sm:w-5 sm:h-5 text-blue-600 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                    </svg>
                    <div>
                      <p className="text-xs sm:text-sm font-semibold text-blue-900 mb-1">
                        Your Lucky Number
                      </p>
                      <p className="text-base sm:text-lg font-bold text-blue-700">
                        {userLuckyNumbers.join(', ')}
                      </p>
                      <p className="text-[10px] sm:text-xs text-blue-600 mt-1">
                        You've entered 1 time for this raffle.
                      </p>
                    </div>
                  </div>
                  <button
                    className="w-full sm:w-auto px-3 py-1.5 sm:px-4 sm:py-2 bg-blue-600 text-white text-xs sm:text-sm font-semibold rounded-lg hover:bg-blue-700 transition-all"
                    onClick={() => navigate('/raffle-result')}
                  >
                    View Results
                  </button>
                </div>
              )}

              {/* Quick Stats */}
              <div className="flex flex-wrap gap-4 sm:gap-6 pt-6 sm:pt-8 border-t border-white/30 justify-center">
                <div className="flex items-center gap-2 sm:gap-3 bg-white text-gradient-to-r from-[#4B975B] to-[#5DAD6D] px-4 py-2 sm:px-5 sm:py-3 rounded-lg shadow-lg">
                  <svg className="w-5 h-5 sm:w-6 sm:h-6 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v2H7a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 100-2h-2V7z" clipRule="evenodd" />
                  </svg>
                  <span className="text-sm sm:text-base font-bold">100% Free Entry</span>
                </div>
                <div className="flex items-center gap-2 sm:gap-3 bg-white text-gradient-to-r from-[#4B975B] to-[#5DAD6D] px-4 py-2 sm:px-5 sm:py-3 rounded-lg shadow-lg">
                  <svg className="w-5 h-5 sm:w-6 sm:h-6 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M6.267 3.455a3.066 3.066 0 001.745-.723 3.066 3.066 0 013.976 0 3.066 3.066 0 001.745.723 3.066 3.066 0 012.812 2.812c.051.643.304 1.254.723 1.745a3.066 3.066 0 010 3.976 3.066 3.066 0 00-.723 1.745 3.066 3.066 0 01-2.812 2.812 3.066 3.066 0 00-1.745.723 3.066 3.066 0 01-3.976 0 3.066 3.066 0 00-1.745-.723 3.066 3.066 0 01-2.812-2.812 3.066 3.066 0 00-.723-1.745 3.066 3.066 0 010-3.976 3.066 3.066 0 00.723-1.745 3.066 3.066 0 012.812-2.812zm7.44 5.252a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                  </svg>
                  <span className="text-sm sm:text-base font-bold">Verified Winners</span>
                </div>
              </div>

              {/* Terms */}
              <p className="text-[10px] sm:text-xs text-white/60">
                *Terms and Conditions apply. Must be 18+ to participate.
              </p>
            </div>
          </div>
        </div>

        {/* Bottom Wave */}
        <div className="absolute bottom-0 left-0 right-0">
          <svg className="w-full h-8 sm:h-10 md:h-12 lg:h-16" viewBox="0 0 1440 120" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
            <path d="M0 120L60 110C120 100 240 80 360 70C480 60 600 60 720 65C840 70 960 80 1080 85C1200 90 1320 90 1380 90L1440 90V120H1380C1320 120 1200 120 1080 120C960 120 840 120 720 120C600 120 480 120 360 120C240 120 120 120 60 120H0Z" fill="#eaf0d5" />
          </svg>
        </div>
      </section>
      {/* <div className="md:px-20 md:py-8 relative bg-[#eaf0d5] md:mx-20 mx-8 my-4 md:my-8 rounded-lg px-6 py-4 "> */}
      {renderTicketModal()}
      {/* {renderSuccessModal()} */}
      {renderThankYouModal()}
      {renderNumberSelectionModal()}
      {/* </div> */}
    </>
  );
};

export default FavoriteRaffle;